import { createStore, Module } from 'vuex-smart-module';
import { ServiceContainer } from '@/services';
import { Router } from 'vue-router';
import { coreModule } from '@/store/core';
import { writeupModule } from '@/store/writeup';
import { stepManagerModule } from '@/store/step-manager';
import { cbcModule } from '@/store/cbc';
import { reserveVehicleModule } from '@/store/reserve-vehicle';
import { Store } from 'vuex';

let store: Store<void>;

export const makeStore = (services: ServiceContainer, router: Router) => {
	const root = new Module({
		modules: {
			coreModule,
			writeupModule,
			stepManagerModule,
			cbcModule,
			reserveVehicleModule,
		},
	});

	store = createStore(
		root,
	);

	const { modules } = root.context(store);

	modules.coreModule.actions.$setDependencies({
		router,
		services,
	});

	modules.writeupModule.actions.$setDependencies({
		services,
	});

	modules.cbcModule.actions.$setDependencies({
		services,
	});

	modules.stepManagerModule.actions.$setDependencies({
		services,
	});

	modules.reserveVehicleModule.actions.$setDependencies({
		services,
	});

	modules.cbcModule.actions.$setDependencies({
		services,
	});

	store.coreModule = modules.coreModule;
	store.writeupModule = modules.writeupModule;
	store.stepManagerModule = modules.stepManagerModule;
	store.cbcModule = modules.cbcModule;
	store.reserveVehicleModule = modules.reserveVehicleModule;

	return store;
};
